import { render, staticRenderFns } from "./ReportView.vue?vue&type=template&id=2e20f82a&scoped=true&"
import script from "./ReportView.vue?vue&type=script&lang=js&"
export * from "./ReportView.vue?vue&type=script&lang=js&"
import style0 from "./ReportView.vue?vue&type=style&index=0&id=2e20f82a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20f82a",
  null
  
)

export default component.exports